module.exports = __webpack_public_path__ + "static/img/bg-es.239bacd9.png";